import React from "react";
import { ChevronLeft, ChevronRight, Calendar, BookOpen, Tag } from "lucide-react";
import "./Article.css";

const Article = ({ article, onNavigateToPrevious, onNavigateToNext }) => {
    if (!article) {
        return <div className="loading-article">Chargement de l'article...</div>;
    }

    const {
        legal_text_title,
        current_article,
        previous_article,
        next_article
    } = article;

    const cleanEnrichedContent = (text) => {
        if (!text) return "";

        // Supprimer tout le contenu entre deux balises (titleenrichi), y compris les balises elles-mêmes
        let cleanedText = text.replace(/\(titleenrichi\).*?\(titleenrichi\)/gs, '');

        // Supprimer toute balise (titleenrichi) restante au cas où il y en aurait des orphelines
        cleanedText = cleanedText.replace(/\(titleenrichi\)/g, '');

        // Nettoyer les lignes vides multiples et les espaces inutiles
        cleanedText = cleanedText.replace(/\n\s*\n/g, '\n').trim();

        return cleanedText;
    };

    return (
        <div className="article-container">
            <h1 className="article-title">
                {current_article.number} - {legal_text_title}
            </h1>

            <div className="article-metadata">
                {current_article.status && (
                    <span className={`status-badge ${current_article.status === "valide" ? "active" : "inactive"}`}>
                        {current_article.status === "valide" ? "En vigueur" : current_article.status}
                    </span>
                )}
            </div>

            <div className="article-navigation">
                {previous_article && (
                    <div
                        className="nav-previous"
                        onClick={onNavigateToPrevious}
                    >
                        <ChevronLeft size={20} className="nav-icon" />
                        <div className="nav-text">
                            <span>Article précédent</span>
                            <strong>{previous_article.number}</strong>
                        </div>
                    </div>
                )}

                {next_article && (
                    <div
                        className="nav-next"
                        onClick={onNavigateToNext}
                    >
                        <div className="nav-text">
                            <span>Article suivant</span>
                            <strong>{next_article.number}</strong>
                        </div>
                        <ChevronRight size={20} className="nav-icon" />
                    </div>
                )}
            </div>

            <div className="article-content">
                <h2 className="content-title">
                    <BookOpen size={20} className="book-icon" />
                    Contenu de l'article
                </h2>
                <div className="content-text">
                    <p>{cleanEnrichedContent(current_article.content)}</p>
                </div>
            </div>
        </div>
    );
};

export default Article;